export const productCategories = [
  { id: "all", name: { nl: "Alle Producten", en: "All Products", tr: "Tüm Ürünler" } },
  { id: "care", name: { nl: "Verzorging & Shampoo", en: "Care & Shampoos", tr: "Şampuan & Bakım" } },
  { id: "styling", name: { nl: "Styling & Finish", en: "Styling & Finish", tr: "Şekillendirici & Sprey" } },
  { id: "tools", name: { nl: "Borstels & Accessoires", en: "Brushes & Tools", tr: "Tarak & Aksesuar" } }
];

export const products = [
  {
    id: "prod-pro-shampoo",
    category: "care",
    badge: "Sulfaatvrij / Sulfatsız",
    name: {
      nl: "Aura Signature Sulfaatvrije & Kleurbeschermende Shampoo",
      en: "Aura Signature Sulfate-Free Color Defense Shampoo",
      tr: "Aura Profesyonel Sülfatsız & Renk Koruyucu Şampuan"
    },
    desc: {
      nl: "Milde reiniging die de haarvezels voedt, gekleurd haar beschermt en de glans tot 8 weken verlengt.",
      en: "Gentle cleansing formula that protects dyed hair, preserves moisture and extends color vibrancy.",
      tr: "Saç rengini koruyan, boyanın ömrünü uzatan ve saçı kurutmadan nazikçe arındıran sülfatsız formül."
    },
    price: 24.5,
    image: "/images/shampoo_product.jpg",
    tags: ["Şampuan", "Sulfaatvrij"]
  },
  {
    id: "prod-deep-conditioner",
    category: "care",
    badge: "Intensieve Hydratatie",
    name: {
      nl: "Diep Voedende & Ontwarrende Conditioner",
      en: "Deep Nourishing & Detangling Hair Conditioner",
      tr: "Yoğun Nemlendirici & Kolay Tarama Saç Kremi"
    },
    desc: {
      nl: "Verrijkt met arganolie en zijdeproteïnen voor zijdezacht, pluisvrij en makkelijk doorkambaar haar.",
      en: "Infused with argan oil and silk proteins for velvety soft, frizz-free and manageable hair.",
      tr: "Argan yağı ve ipek proteinleri ile saçı ipeksi yapar, elektriklenmeyi önler ve anında yumuşatır."
    },
    price: 22.0,
    image: "/images/conditioner_product.jpg",
    tags: ["Saç Kremi", "Conditioner"]
  },
  {
    id: "prod-keratin-mask",
    category: "care",
    badge: "Salon Therapie",
    name: {
      nl: "Intensief Herstellend Keratine & Argan Haarmasker",
      en: "Intensive Repair Keratin & Argan Hair Mask",
      tr: "Yoğun Onarıcı Keratin & Argan Saç Maskesi"
    },
    desc: {
      nl: "Herstelt beschadigd, gebleekt en droog haar van binnenuit. Geeft diepe veerkracht en spiegelglans.",
      en: "Deep-penetrating therapy that repairs heat-damaged and color-treated hair with instant mirror shine.",
      tr: "Yıpranmış, boyalı ve kuru saç tellerini içten onarır; saça elastikiyet ve göz alıcı parlaklık katar."
    },
    price: 29.0,
    image: "/images/mask_product.jpg",
    tags: ["Saç Maskesi", "Keratine"]
  },
  {
    id: "prod-hair-oil-serum",
    category: "care",
    badge: "Pure Elixir",
    name: {
      nl: "Luxe Argan & Keratine Haarolie / Serum",
      en: "Luxury Argan & Keratin Hair Treatment Oil / Serum",
      tr: "Lüks Argan & Keratin Saç Bakım Yağı ve İpeksi Serum"
    },
    desc: {
      nl: "Gewichtloos serum dat gespleten haarpunten sluit, pluis tegengaat en een fantastische geur achterlaat.",
      en: "Weightless elixir that seals split ends, shields against heat and provides brilliant radiant shine.",
      tr: "Kırık uçları onaran, ısıya karşı koruyan ve ağırlaştırmadan parlatan mucizevi bakım serumu."
    },
    price: 26.0,
    image: "/images/serum_product.jpg",
    tags: ["Serum", "Haarolie"]
  },
  {
    id: "prod-styling-spray-wax",
    category: "styling",
    badge: "Sterke Fixatie & Glans",
    name: {
      nl: "Professionele Haarspray, Matte Pomade & Styling Wax",
      en: "Professional Hair Spray, Matte Pomade & Styling Wax",
      tr: "Profesyonel Saç Spreyi, Mat Pomad & Şekillendirici Wax"
    },
    desc: {
      nl: "24-uurs betrouwbare hold zonder residu. Geschikt voor strakke fades, volume en moderne kapsels.",
      en: "24-hour strong hold without flaking. Ideal for sharp textured crops, pompadours and sleek looks.",
      tr: "Kalıntı bırakmayan, 24 saat güçlü tutuş sağlayan berber serisi sprey, kil wax ve mat pomad."
    },
    price: 19.5,
    image: "/images/spray_product.jpg",
    tags: ["Sprey", "Wax", "Pomade"]
  },
  {
    id: "prod-hair-colors",
    category: "care",
    badge: "Salon Formula",
    name: {
      nl: "Professionele Ammoniakvrije Haarkleuringen & Toners",
      en: "Professional Ammonia-Free Hair Colors & Toners",
      tr: "Profesyonel Amonyaksız Saç Boyaları & Özel Tonlayıcılar"
    },
    desc: {
      nl: "Rijke pigmenten met 100% grijsdekking en langdurige kleurintensiteit voor thuis- en salononderhoud.",
      en: "Rich micro-pigments with 100% grey coverage and radiant long-lasting color intensity.",
      tr: "%100 beyaz kapama, zengin renk pigmentleri ve saçı yıpratmayan besleyici salon formülü."
    },
    price: 18.0,
    image: "/images/dye_product.jpg",
    tags: ["Boya", "Haarkleuring"]
  },
  {
    id: "prod-brushes-combs",
    category: "tools",
    badge: "Antistatisch / Antistatik",
    name: {
      nl: "Keramische Föhnborstels & Massagekammen",
      en: "Ceramic Blow-Dry Brushes & Massage Combs",
      tr: "Termal Seramik Fön Fırçaları & Masaj Tarak Seti"
    },
    desc: {
      nl: "Professionele thermische borstels die de droogtijd halveren en haarbreuk drastisch verminderen.",
      en: "Professional ionic ceramic brushes that speed up blow-drying while eliminating static flyaways.",
      tr: "Fön süresini yarıya indiren, statik elektriği önleyen ve saç derisine masaj yapan termal fırçalar."
    },
    price: 21.0,
    image: "/images/brush_product.jpg",
    tags: ["Tarak", "Fırça", "Borstel"]
  },
  {
    id: "prod-pro-care-kit",
    category: "care",
    badge: "Complete Salon Set",
    name: {
      nl: "Aura Pro Salon Haarverzorging & Herstelset (Full Set)",
      en: "Aura Pro Complete Salon Hair Care & Recovery Kit",
      tr: "Aura Profesyonel Saç Bakım & Yenileme Kiti (Tam Set)"
    },
    desc: {
      nl: "Inclusief shampoo, conditioner, intensief masker en serum voor de complete salonervaring thuis.",
      en: "Complete 4-piece restorative kit: Shampoo, Conditioner, Intensive Mask and Elixir Serum.",
      tr: "Şampuan, saç kremi, yoğun maske ve serumdan oluşan eksiksiz 4'lü lüks profesyonel bakım seti."
    },
    price: 79.0,
    image: "/images/kit_product.jpg",
    tags: ["Set", "Salon Set"]
  }
];
